export const BLOC_OU_SURFACE = {
	BLOC: { value: 'BLOC', label: 'Bloc' },
	SURFACE: { value: 'SURFACE', label: 'Surface' }
}

export const ERROR_TYPE_VALIDATION = {
	DUPLICATION_NOM: 'duplicateName',
	ASSOLEMENT_LIE: 'assolementConstraint',
	MATRICE_SANS_BLOC: 'matriceBlocVide'
}